module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.12-78.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.12.md
// module id = 495
// module chunks = 354